export default __webpack_public_path__ + "static/media/excel.5b18300d.svg";